export const CONFIG = {
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  API: `${process.env.REACT_APP_API_HOST}/api`,
  CORE_SERVICE_API_HOST: `${process.env.REACT_APP_CORE_SERVICE_API_HOST}/service/api`,
  NON_EMCS_API_HOST: `${process.env.REACT_APP_NON_EMCS_API_HOST}/non-emcs`,
}
